import { http } from "~/utils";
export default {
    getCostpackages: async (page = 1, filters = {}) => {
        const newFilters = Object.keys(filters).reduce((result, key) => {
            const value = filters[key];
            const splitKey = key.split("__");
            let newKey = key;
            if (splitKey.length === 1 && key !== "cancelled") {
                newKey = `${key}__icontains`;
            }
            return {
                ...result,
                [newKey]: value
            };
        }, {});
        return http
            .get("/cost-package-management/cost-package/", {
                params: { ...newFilters, page }
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    getCostpackageDetail: async voa_id => {
        return await http.get(`/cost-package-management/cost-package/${voa_id}/`).then(response => response.data);
    },
    requestReport: async () => {
        return await http
            .post("/cost-package-management/cost-package-sales-item/report/")
            .then(response => response.data);
    }
};
